function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useState } from 'react';
import cn from 'classnames';
import { Badge, IconButton, TextButton, TextField, Tooltip, Typography } from 'seagull';
import { TrashLiner24 } from 'seagull/icons';
import ChangesApprovalInfoBox from "../ChangesApprovalInfoBox/ChangesApprovalInfoBox";
import styles from "./AmendmentChanges.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function AmendmentNote(props) {
  const {
    testId,
    existingNote,
    isUnsaved,
    onNoteChange
  } = props;
  const [note, setNote] = useState(existingNote || '');
  const [addingNote, setAddingNote] = useState(!!existingNote);
  return isUnsaved ? /*#__PURE__*/_jsx("div", {
    className: styles.note,
    children: addingNote ? /*#__PURE__*/_jsx(TextField, {
      collapseHelperText: false,
      multiline: true,
      label: "Note",
      value: note,
      testId: testId && "".concat(testId, "-note"),
      onChange: e => {
        const newNote = e.target.value;
        setNote(newNote);
        onNoteChange && onNoteChange(newNote);
      }
    }) : /*#__PURE__*/_jsx(TextButton, {
      underline: "none",
      testId: testId && "".concat(testId, "-add-note"),
      onClick: () => setAddingNote(true),
      children: "+ Add Note"
    })
  }) : existingNote ? /*#__PURE__*/_jsxs("div", {
    className: styles.note,
    children: [/*#__PURE__*/_jsx(Typography, {
      weight: "normal",
      as: "span",
      children: "Note:"
    }), ' ', /*#__PURE__*/_jsx(Typography, {
      as: "span",
      testId: testId && "".concat(testId, "-readonly-note"),
      children: existingNote
    })]
  }) : null;
}
export default function AmendmentChanges(props) {
  const {
    items,
    testId,
    autoApprovalDate,
    isUnsaved,
    disableNote,
    disableDiscard,
    disableRequiresApprovalBadges,
    disableApprovalInfoBox,
    disableBorderRadius,
    title = 'Changes',
    onDiscard
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles.changes, {
      [styles.disableBorderRadius]: disableBorderRadius
    }),
    "data-testid": testId,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.title,
      children: [/*#__PURE__*/_jsx(Typography, {
        weight: "normal",
        children: title
      }), items.length > 0 && !disableDiscard && /*#__PURE__*/_jsx(Tooltip, {
        title: "Discard all changes",
        children: /*#__PURE__*/_jsx(IconButton, {
          type: "button",
          size: "small",
          noPadding: true,
          testId: testId && "".concat(testId, "-discard"),
          onClick: onDiscard,
          children: /*#__PURE__*/_jsx(TrashLiner24, {
            size: 16
          })
        })
      })]
    }), items.length > 0 && /*#__PURE__*/_jsx("ul", {
      className: styles.items,
      children: items.map((_ref, idx) => {
        let {
          text,
          requiresApproval
        } = _ref;
        return /*#__PURE__*/_jsx(Typography, {
          as: "li",
          className: styles.item,
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.itemContent,
            children: [/*#__PURE__*/_jsx(Typography, {
              as: "span",
              testId: testId && "".concat(testId, "-").concat(idx),
              children: text
            }), requiresApproval && !disableRequiresApprovalBadges && /*#__PURE__*/_jsx(Badge, {
              outlined: true,
              rounded: true,
              skin: "warning",
              className: styles.requiresApproval,
              testId: testId && "".concat(testId, "-").concat(idx, "-requires-approval"),
              children: "Requires approval"
            })]
          })
        }, text);
      })
    }), !disableNote && /*#__PURE__*/_jsx(AmendmentNote, _objectSpread({}, props)), !disableApprovalInfoBox && !isUnsaved && items.some(item => item.requiresApproval) && /*#__PURE__*/_jsx(ChangesApprovalInfoBox, {
      className: styles.infoBox,
      testId: testId && "".concat(testId, "-approval-info"),
      autoApprovalDate: autoApprovalDate
    })]
  });
}